import React from 'react';
import { Link } from 'react-router-dom';
import whiteLogo from '../images/WhiteKaizekLogo.svg';
import ScrollButton from './ScrollButton';

const Footer = () => {

    const handleScroll = (event, sectionId) => {
        event.preventDefault(); // Prevent default anchor behavior
    
        const section = document.getElementById(sectionId);
        if (section) {
          section.scrollIntoView({ behavior: "smooth", block: "start" });
        }
      };

    return (
        <>
        <ScrollButton/>
            <div className='py-4 sm:py-8 lg:py-12 items-center bg-[var(--kaizekblue)]'>
                <div className='border-b-[0.0625rem] border-[var(--lightgray)] pb-4 lg:pb-8 mx-6 sm:mx-8 lg:mx-14 grid sm:grid-cols-3 gap-4 sm:gap-6 lg:gap-8 xl:gap-10'>
                    <div className='sm:mx-auto'>
                        <Link to={"/"}><img src={whiteLogo} alt="Kaizek-logo" className='2xl:w-64'/></Link>
                    </div>
                    <div className='sm:mx-auto'>
                        <h1 className='font-symbol text-2xl lg:text-3xl 2xl:text-[2.5rem] lg:leading-tight font-semibold text-[var(--whitetext)] py-2 sm:pb-8'>Engineering the future of connected devices</h1>
                        <h1 className='font-uiBold text-base text-white pb-4'>Contact</h1>
                        <h1 className='font-symbol text-base text-[var(--whitetext)]'><Link to="mailto:info@kaizek.com">info@kaizek.com</Link></h1>
                    </div>
                    <div className='sm:mx-auto'>
                        <h1 className='font-uiBold text-base text-white pb-4 lg:pb-6'>Services</h1>
                        <ul className='font-symbol text-base text-[var(--whitetext)]'>
                            <li className='py-1 underline decoration-white md:decoration-[var(--kaizekblue)]'><a href="#services" onClick={(e) => handleScroll(e, "services")}>Core Services</a></li>
                            <li className='py-1 underline decoration-white md:decoration-[var(--kaizekblue)]'><a href="#capabilities" onClick={(e) => handleScroll(e, "capabilities")}>Technical Capabilities</a></li>
                            <li className='py-1 underline decoration-white md:decoration-[var(--kaizekblue)]'><a href="#smartcity" onClick={(e) => handleScroll(e, "smartcity")}>Smart City Solutions</a></li>
                            <li className='py-1 underline decoration-white md:decoration-[var(--kaizekblue)]'><a href="#integration" onClick={(e) => handleScroll(e, "integration")}>Integration Services</a></li>
                            <li className='py-1 underline decoration-white md:decoration-[var(--kaizekblue)]'><a href="#casestudies" onClick={(e) => handleScroll(e, "casestudies")}>Case Studies</a></li>
                        </ul>
                    </div>
                    
                </div>
                <div className='mt-4 lg:mt-6 grid sm:grid-flow-col lg:grid-cols-3 mx-6 sm:mx-8 lg:mx-16 2xl:mx-20'>
                    <div className='hidden lg:flex'></div>
                    <div>
                        <h2 className='font-symbol text-base lg:text-lg text-[var(--whitetext)] lg:text-center my-2 sm:my-0'>© 2025 Kaizek. All rights reserved.</h2>
                    </div>
                    <div className='flex sm:flex-row items-center sm:place-content-end my-2 sm:my-0'>
                        <Link to='/privacy-policy' className='underline decoration-white md:decoration-[var(--kaizekblue)] hover:font-semibold'><p className='font-symbol text-base text-[var(--whitetext)] text-center pe-4'>Privacy Policy</p></Link>
                        <Link to='/terms-of-use' className='underline decoration-white md:decoration-[var(--kaizekblue)] hover:font-semibold'><p className='font-symbol text-base text-[var(--whitetext)] text-center'>Terms of use</p></Link>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Footer